import React from "react";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`;

const SpinningSvg = styled.svg`
  animation: ${spin} 0.8s linear infinite;
`;

export const Loading = () => (
  <SpinningSvg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
      <path
        d="M12.5627 7.39319V4.75989C12.5627 4.3963 12.268 4.10156 11.9044 4.10156C11.5408 4.10156 11.2461 4.3963 11.2461 4.75989V7.39319C11.2461 7.75677 11.5408 8.05151 11.9044 8.05151C12.268 8.05151 12.5627 7.75677 12.5627 7.39319Z"
        fill="currentColor"
      />
      <path
        opacity="0.9"
        d="M16.557 6.41578L14.695 8.27778C14.4379 8.53487 14.4379 8.9517 14.695 9.20879C14.9521 9.46588 15.3689 9.46588 15.626 9.20879L17.488 7.34678C17.7451 7.08969 17.7451 6.67287 17.488 6.41578C17.2309 6.15869 16.8141 6.15869 16.557 6.41578Z"
        fill="currentColor"
      />
      <path
        opacity="0.8"
        d="M19.1442 11.3405H16.5109C16.1473 11.3405 15.8525 11.6352 15.8525 11.9988C15.8525 12.3624 16.1473 12.6571 16.5109 12.6571H19.1442C19.5077 12.6571 19.8025 12.3624 19.8025 11.9988C19.8025 11.6352 19.5077 11.3405 19.1442 11.3405Z"
        fill="currentColor"
      />
      <path
        opacity="0.7"
        d="M17.488 16.6587L15.626 14.7967C15.3689 14.5396 14.9521 14.5396 14.695 14.7967C14.4379 15.0538 14.4379 15.4706 14.695 15.7277L16.557 17.5897C16.8141 17.8468 17.2309 17.8468 17.488 17.5897C17.7451 17.3326 17.7451 16.9158 17.488 16.6587Z"
        fill="currentColor"
      />
      <path
        opacity="0.6"
        d="M12.5627 19.2482V16.6149C12.5627 16.2513 12.268 15.9565 11.9044 15.9565C11.5408 15.9565 11.2461 16.2513 11.2461 16.6149V19.2482C11.2461 19.6118 11.5408 19.9065 11.9044 19.9065C12.268 19.9065 12.5627 19.6118 12.5627 19.2482Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        d="M8.33044 14.4655L6.46843 16.3275C6.21134 16.5846 6.21134 17.0014 6.46843 17.2585C6.72552 17.5156 7.14235 17.5156 7.39943 17.2585L9.26144 15.3965C9.51853 15.1394 9.51853 14.7225 9.26144 14.4655C9.00435 14.2084 8.58753 14.2084 8.33044 14.4655Z"
        fill="currentColor"
      />
      <path
        opacity="0.4"
        d="M7.29553 11.3405H4.66223C4.29865 11.3405 4.00391 11.6352 4.00391 11.9988C4.00391 12.3624 4.29865 12.6571 4.66223 12.6571H7.29553C7.65911 12.6571 7.95386 12.3624 7.95386 11.9988C7.95386 11.6352 7.65911 11.3405 7.29553 11.3405Z"
        fill="currentColor"
      />
      <path
        opacity="0.3"
        d="M9.1091 8.27541L7.24709 6.4134C6.99 6.15632 6.57318 6.15632 6.31609 6.4134C6.059 6.67049 6.059 7.08732 6.31609 7.34441L8.17809 9.20641C8.43518 9.4635 8.85201 9.4635 9.1091 9.20641C9.36619 8.94933 9.36619 8.5325 9.1091 8.27541Z"
        fill="currentColor"
      />
  </SpinningSvg>
);
